import { createAction, handleActions } from "redux-actions"
import { apiGet, apiPost } from "../utils/apiConnector"
import { getAlcoApi } from "../config/apiUrls"

const defaultState = {
  alcohol: [],
  totalCount: 0,
  okAlco: 0,
  palyonka: 0,
}

const getAlcohol = createAction("GET_ALCOHOL")
const incrementOk = createAction("INCREMENT_OK")
const incrementNoOk = createAction("INCREMENT_NO_OK")

const reducers = handleActions(
  {
    [getAlcohol]: (state, { payload }) => ({
      ...state,
      alcohol: [...state.alcohol, ...payload],
      totalCount: state.totalCount + 1,
    }),
    [incrementOk]: (state, { payload }) => ({
      ...state,
      okAlco: state.okAlco + 1,
    }),
    [incrementNoOk]: (state) => ({
      ...state,
      palyonka: state.palyonka + 1,
    }),
  },
  defaultState,
)
export default reducers

export function getAlcoholFunc(barcode) {
  return (dispatch) => {
    apiPost(getAlcoApi, { usid: barcode })
      .onOk((res) => {
        dispatch(getAlcohol(res.data.response.items))
        if (res.data.response.items[0].isVerified) {
          dispatch(incrementOk())
        } else {
          dispatch(incrementNoOk())
        }
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}
